/**
 * Lazy Mermaid loader — nur bei Bedarf importieren (Bundle-Splitting).
 *
 * Importer ist injizierbar für Tests (mermaid 11 braucht echte Browser-DOM
 * und kann nicht in happy-dom laufen — Tests injizieren stattdessen einen Mock).
 */
type MermaidLike = {
  initialize: (config: { startOnLoad?: boolean; theme?: string; securityLevel?: string }) => void;
  render: (id: string, code: string) => Promise<{ svg: string }>;
};

let mermaidPromise: Promise<MermaidLike> | null = null;

/** Standard-Importer: lädt das echte `mermaid`-Paket (lazy, Bundle-Splitting). */
export function defaultMermaidImporter(): Promise<{ default: MermaidLike }> {
  return import('mermaid') as unknown as Promise<{ default: MermaidLike }>;
}

let importer: () => Promise<{ default: MermaidLike }> = defaultMermaidImporter;

/** Test-Hook: alternativen Importer injizieren (Mock) und Cache invalidieren. */
export function setMermaidImporter(fn: () => Promise<{ default: MermaidLike }>): void {
  importer = fn;
  mermaidPromise = null;
}

export async function getMermaid(): Promise<MermaidLike> {
  if (!mermaidPromise) {
    mermaidPromise = importer().then((m) => {
      m.default.initialize({ startOnLoad: false, theme: 'default', securityLevel: 'strict' });
      return m.default;
    });
  }
  return mermaidPromise;
}

export async function renderMermaid(id: string, code: string): Promise<{ svg: string }> {
  const mermaid = await getMermaid();
  return mermaid.render(id, code);
}
